import React from 'react'

export default class EmptyComponent extends React.Component {
  render() {
    return <div className="empty-component" />
  }
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/components/emptyComponent.js